import React, { useEffect, useState } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import { STATES_DATA } from '../../../../lib/constants'
import LayerCategoryListItem from '../LayerCategoryListItem'
import SidebarBody from '../../SidebarBody'
import SidebarDetailHeader from '../../SidebarDetailHeader'
import StarIcon from '../../../../assets/svg/StarIcon'
import Loader from '../../../Loader'
import styles from './LayerCategoryListSidebar.module.scss'

function LayerCategoryListSidebar(props) {
	const [stateName, setStateName] = useState(null)
  const [stateIcon, setStateIcon] = useState(null)
  const [statePhoto, setStatePhoto] = useState(null)

  useEffect(() => {
		setStateName(props.stateName.replace(' ', '_'))
    setStateIcon(`${props.assetsUrl}/states/icons/small/${STATES_DATA[props.stateName]?.abbrev.toLowerCase()}.png`)
    setStatePhoto(`${props.assetsUrl}/states/heroes/small/${STATES_DATA[props.stateName]?.abbrev.toLowerCase()}.jpg`)
  }, [])

  const handleFavoriteState = () => {
    props.dispatch({
      type: 'layers/setFavoriteStates',
      payload: {
        states: [stateName]
      }
    })
  }

  return (
    <>
      <SidebarDetailHeader
        title={props.stateName}
        titleIcon={
          stateIcon ? (
            <img src={stateIcon} height={24} width={24} />
          ) : (
            <div className={styles.loader}>
              <Loader active={true} />
            </div>
          )
        }
        titlePhoto={
          <>
            <img src={statePhoto} height={176} />
            <div className={styles.favoriteSection}>
              <i className={styles.favoriteIcon} onClick={handleFavoriteState}>
                <StarIcon size={22} fill={props.isFavorited ? '#fff' : undefined} />
              </i>
              <p className={styles.favoriteTitle}>Favorite</p>
            </div>
          </>
        }
      />
      <SidebarBody>
        {props.categories.map((category, i) => {
          return (
            <LayerCategoryListItem
              key={i}
              category={category}
              categoryIsOpen={props.categoryName === category.categoryName}
              categoryName={category.categoryName}
              dispatch={props.dispatch}
              stateName={props.stateName}
              userProfile={props.userProfile}
            />
          )
        })}
      </SidebarBody>
    </>
  )
}

LayerCategoryListSidebar.propTypes = {
  assetsUrl: PropTypes.string,
  preferences: PropTypes.object,
  categories: PropTypes.array,
  categoryIsOpen: PropTypes.bool,
  categoryName: PropTypes.string,
  isFavorited: PropTypes.bool,
  stateName: PropTypes.string,
  userProfile: PropTypes.object
}

export default connect(model => {
  const userProfile = model.user.profile
  const config = model.app.config
  const { layersByEvent, layersByState, preferences, selected } = model.layers
  const { categoryIsOpen, categoryName, stateName } = selected
  const allLayers = [...layersByEvent, ...layersByState]
  const stateInfo = allLayers.find(stateObj => stateObj.stateName == stateName)
  const isFavorited = stateName ? preferences.favorites.states.includes(stateName.replace(' ', '_')) : false
  return {
    assetsUrl: config.GH_ASSETS_CLOUDFRONT_URL,
    categories: stateInfo?.categories || [],
    categoryIsOpen,
    categoryName,
    isFavorited,
    stateName,
    userProfile
  }
})(LayerCategoryListSidebar)
